module.exports = __webpack_public_path__ + "static/img/1.2c7a23ea.png";